/**
 * De onde o calendário tira os feriados.
 *
 * Padrão: os feriados nacionais calculados no navegador (`utils/calculos`),
 * como sempre foi em Entregas. Quem tem uma lista própria — a Gestão de
 * Solicitações usa o calendário da unidade, o MESMO que conta os dias úteis
 * dos prazos — passa `feriados` ({"AAAA-MM-DD": nome}) e ela vale sozinha.
 */
import { getNomeFeriado, isFeriado } from "../../utils/calculos";

function chave(data) {
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
}

/** (Date) => nome do feriado ou null. */
export function consultaDeFeriado(feriados) {
  if (feriados) return (data) => feriados[chave(data)] || null;
  return (data) => (isFeriado(data) ? getNomeFeriado(data) : null);
}
